<template>
  <div class="row">
    <div class="flex md12" style="font-size: 15px, color: black">
      <vxe-toolbar>
        <template #buttons>
          <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input a key word"
            @keyup="searchEvent_detable"
          ></vxe-input>
          <!-- <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download
          </vxe-button> -->
        </template>
      </vxe-toolbar>
      <!-- end -->
      <!-- :expand-config="{ expandAll: true }" -->
      <vxe-table
        border
        show-overflow
        :data="tableData_detable"
        :row-config="{ height: 30 }"
        row-id="id"
        size="small"
        ref="xTable"
        class="mytable"
        align="center"
        header-align="center"
      >
        <vxe-column type="expand" width="40">
          <template #content="{ row }">
            <span
              v-for="(index, element) in row.genelist.split(',')"
              :key="index"
              :value="element"
            >
              <a-tag
                style="margin: 4px 4px"
                onmouseover="this.style.cursor='pointer'"
              >
                {{ index }}</a-tag
              >
              <br v-if="(element + 1) % 8 === 0" />
            </span>
          </template>
        </vxe-column>
        <vxe-column
          field="pathway"
          title="Complex name"
          type="html"
          width="40%"
        ></vxe-column>
        <vxe-column
          field="num"
          title="Candidate contained"
          type="html"
        ></vxe-column>
        <vxe-column
          field="qvalue"
          title="P-value"
          type="html"
          width="20%"
        ></vxe-column>
        <vxe-column
          field="source"
          title="Data origion"
          type="html"
        ></vxe-column>
        <template #empty>
          <span style="color: grey"> No records found! </span>
        </template>
      </vxe-table>
      <vxe-pager
        background
        size="small"
        :loading="loading_detable"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[10]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          // 'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import XEUtils from "xe-utils";

export default {
  // props: ["selectgene"],
  data() {
    return {
      // tableData: [],
      //加载
      spinning: true,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
  created() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/clusters/pcDetailsPathway.php",
        {
          params: {
            clusterID: this.$route.query.pcID,
          },
        }
      )
      .then((response) => {
        this.getdata_detable = response.data["complex"];
        this.findList_detable(this.getdata_detable);
        this.tablePage_detable.currentPage = 1; //必须重置到第一页
        this.spinning = false;
      });
  },
  methods: {
    //页面跳转
    goDrugDetails(value, value2) {
      let routeData = this.$router.resolve({
        name: "drugModelResult",
        query: { drugid: value, dName: value2 },
      });
      window.open(routeData.href, "_blank");
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    // 分页响应按钮
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    //全标查询
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1; //必须重置到第一页
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["pathway", "genelist"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.findList_detable(this.getdata_detable);
      }
    },
    // 导出底物蛋白列表
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: this.selectgene + "_all_perturbation_Similarity",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        if (this.filterName_detable == "" || this.filterName_detable == " ") {
          const list = this.getdata_detable;
          this.$refs.xTable.exportData({
            filename: this.selectgene + "_all_perturbation_Similarity",
            type: "csv",
            isHeader: true,
            isFooter: true,
            data: list,
          });
        } else {
          const list = this.tempdata_detable;
          this.$refs.xTable.exportData({
            filename:
              this.filterName_detable + "_related_perturbation_Similarity",
            type: "csv",
            isHeader: true,
            isFooter: true,
            data: list,
          });
        }
      }
    },
  },
};
</script>
<style></style>
